// @ts-nocheck -> por la propiedad exact
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import LoginView from '@/views/LoginView'
import Login from '@/components/Auth/Login'
import AppList from '@/components/AppsUI/AppList'
import UserSettings from '@/components/UserSettings/UserSettings'
import AccountSettings from '@/components/AccountSettings/AccountSettings'
import ForgotPassword from '@/components/Auth/ForgotPassword'
import ResetPassword from '@/components/Auth/ResetPassword'
import VerificationLinkSent from '@/components/Auth/VerificationLinkSent'
import RegisterView from '@/views/RegisterView'
import NotFoundView from '@/views/NotFoundView'
import GeneralView from '@/views/GeneralView'
import CreatePassword from '@/components/Register/CreatePassword'
import WelcomeMailResend from '@/components/Register/WelcomeMailResend'
import SetPasswordSuccesfull from '@/components/Register/SetPasswordSuccesfull'
import PasswordResetSuccesfull from '@/components/Auth/PasswordResetSuccesfull'

import store from '@/store'
import { ConnectionWSShared } from '@leapsight/styleguide'
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/portal',
    name: 'portal',
    component: GeneralView,
    meta: {
      requiresAuth: true
    },
    redirect: '/portal/launcher',
    children: [
      //App List
      {
        path: 'launcher',
        name: 'launcher',
        component: AppList
      },
      //User Settings
      {
        path: 'user-settings',
        name: 'user-settings',
        component: UserSettings
      },
      //Account Settings
      {
        path: 'account-settings',
        name: 'account-settings',
        component: AccountSettings
      }
    ]
  },
  //Login
  {
    path: '/portal/login',
    name: 'login-view',
    component: LoginView,
    children: [
      {
        path: '',
        name: 'login',
        component: Login,
        beforeEnter(to, from, next) {
          store.dispatch('auth/logout')
          next()
        }
      },
      //Forgot Password
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: ForgotPassword
      },
      //Verification Link Sent Password
      {
        path: 'verification-link-sent',
        name: 'verification-link-sent',
        component: VerificationLinkSent
      },
      //Reset Password
      {
        path: 'reset-password/:username/:password_code/:user_id',
        name: 'reset-password',
        component: ResetPassword
      },
      {
        path: 'password-reset-succesfull',
        name: 'password-reset-succesfull',
        component: PasswordResetSuccesfull
      }
    ],
    beforeEnter(to, from, next) {
      store.dispatch('auth/checkTokenIsActive').then(function(response) {
        // Si hay algun usuario logueado al hacer un recupero de contraseña se procede a su deslogueo
        if (
          response &&
          to.name == 'reset-password' &&
          store.getters['auth/isLoggedIn']
        ) {
          store.dispatch('auth/logout').then(function(response) {
            next()
          })
          // Si el usuario ya esta logeado lo redirijo al launcher
        } else if (
          response &&
          store.getters['auth/isLoggedIn'] &&
          !store.getters['auth/termsConditionsBlocker']
        ) {
          next({ name: 'launcher' })
        } else {
          next()
        }
      })
    }
  },

  //Register
  {
    path: '/portal/register',
    name: 'register',
    component: RegisterView,
    children: [
      {
        path: ':username/:password_code/:user_id',
        name: 'CreatePassword',
        component: CreatePassword
      },
      {
        path: 'welcome-mail-resend',
        name: 'welcome-mail-resend',
        component: WelcomeMailResend
      },
      {
        path: 'set-password-succesfull',
        name: 'set-password-succesfull',
        component: SetPasswordSuccesfull,
        beforeEnter: (to, from, next) => {
          // Si se intenta ingresar a la ruta de forma manual sera redirigido al login
          if (from.name !== 'CreatePassword') {
            next({ name: 'login' })
          } else next()
        }
      }
    ]
  },
  {
    path: '/live-tracking',
    name: 'live-tracking'
  },
  {
    path: '/fleet-management',
    name: 'fleet-management'
  },
  //404
  {
    path: '*',
    name: 'notFound',
    component: NotFoundView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //Permito seguir si el token es válido, se encuentra logeado y no hay
    //bloqueo por términos y condiciones
    if (
      store.getters['auth/isLoggedIn'] &&
      store.getters['auth/termsConditionsBlocker']
    ) {
      next()
    } else if (
      store.getters['auth/isLoggedIn'] &&
      !store.getters['auth/termsConditionsBlocker']
    ) {
      next()
    } else {
      store.dispatch('auth/logout').then(() => {
        next({ name: 'login' })
      })
    }
  } else {
    //No se requiere auth
    next()
  }
})

window.addEventListener('beforeunload', event => {
  ConnectionWSShared.closeConnection()
})

export default router
